import { render, staticRenderFns } from "./BandBannerListPage.vue?vue&type=template&id=0bca29a7&scoped=true&"
import script from "./BandBannerListPage.vue?vue&type=script&lang=js&"
export * from "./BandBannerListPage.vue?vue&type=script&lang=js&"
import style0 from "./BandBannerListPage.vue?vue&type=style&index=0&id=0bca29a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca29a7",
  null
  
)

export default component.exports